// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"407":"panel","441":"superadmin","884":"admin","933":"auth"}[chunkId] || chunkId) + "." + {"306":"49b549d8","407":"9367cc9d","409":"31484b92","441":"ffeda83f","884":"4c5bfb84","933":"b2d2ff4f","981":"a9d1ea5c"}[chunkId] + ".js";
};